import { AppState } from 'store/store';

export const departmentSettingsSelector = (state: AppState) => state.user.departmentSettings;
export const officialSettingsSelector = (state: AppState) => state.user.userSettings;
export const userOfficialRole = (state: AppState) => state.user.userSettings.role;
export const userOfficialPermissions = (state: AppState) => state.user.userSettings.permissions;
export const userOfficialPermissionsReady = (state: AppState) => state.user.userSettings.permissionsReady;
export const userId = (state: AppState) => state.user.userSettings.id;
